<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">Du har blitt logget ut</h3>
        </div>
      </div>

      <div class="modal-window-body gray">
        <fieldset>
          <div class="grid-x grid-padding-x">
            <div class="cell" v-show="error">
              <div class="panel center error">
                Feil brukernavn <em>eller</em> passord
              </div>
            </div>

            <div class="cell">
              <label for="username">Brukernavn</label>
              <div class="input-container text">
                <input type="text" id="username" name="username" v-model="username">
              </div>
            </div>

            <div class="cell">
              <label for="password">Passord</label>
              <div class="input-container password">
                <input :type="passwordType" id="password" name="password" v-model="password">
                <a href="javascript:;" class="password-toggle" @click="tooglePasswordType()" tabindex="-1">
                  <svg :class="[passwordType === 'password' ? 'not-visible' : 'visible']" width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-invisible"></use></svg>
                  <svg :class="[passwordType === 'password' ? 'visible' : 'not-visible']" width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-visible"></use></svg>
                </a>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a href="javascript:;" @click="cancel()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-if="!processing" href="javascript:;" @click="handleSubmit()" class="button primary submit large">Logg inn</a>
            <a v-else href="javascript:;" class="button primary submit large loading" disabled>Logger inn...<span class="loader-spinner"></span></a>
          </div>
        </div>
      </div>
    </form>
  </overlay-scrollbars>
</template>

<script>
import { AUTH_REQUEST, AUTH_LOGOUT } from '../../store/actions/auth'
import { mapGetters } from 'vuex'

export default {
  name: 'LoginModal',
  data () {
    return {
      username: '',
      password: '',
      error: '',
      passwordType: 'password',
      processing: false
    }
  },
  mounted () {
    window.jQuery('#username').focus()
  },
  methods: {
    tooglePasswordType: function () {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    cancel: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.replace('/')
        this.$emit('close')
      })
    },
    handleSubmit: function () {
      if (this.processing) {
        return
      }

      this.processing = true
      this.error = false

      const { username, password } = this

      this.$store.dispatch(AUTH_REQUEST, { username, password })
        .then(() => {
          this.$helpers.showSuccessAlert(
            'Ok',
            'Du er nå logget inn. Oppdater nettsiden eller fortsett der du var.<br><a href="javascript:window.location.reload()">Last om siden...</a>',
            true,
            15000
          )

          this.$emit('close')
        })
        .catch(() => {
          this.error = true
        })
        .then(() => {
          this.processing = false
        })
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Guest/LoginModal.vue